import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { api } from "../lib/api";

const STORAGE_KEY = "lif_banner_dismissed";

export default function SiteBanner() {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/site/banner").then((r) => {
      const b = r.data;
      if (!b || !b.banner_id) return;
      const last = localStorage.getItem(STORAGE_KEY);
      if (last === b.banner_id) return; // already dismissed this banner
      setBanner(b);
    }).catch(() => {});
  }, []);

  if (!banner || dismissed) return null;

  const isExternal = banner.cta_url && /^https?:\/\//.test(banner.cta_url);

  function close() {
    localStorage.setItem(STORAGE_KEY, banner.banner_id);
    setDismissed(true);
  }

  return (
    <div
      data-testid="site-banner"
      className="w-full text-center text-[12px] md:text-[13px] tracking-wide"
      style={{ background: banner.bg_color || "#111111", color: banner.text_color || "#C8A96B" }}
    >
      <div className="container-wide px-6 md:px-12 py-2 flex items-center justify-center gap-3 relative">
        {banner.show_logo !== false && (
          <img
            src={`${process.env.REACT_APP_BACKEND_URL}/api/brand/logo.png`}
            alt="LockedInForever"
            className="h-7 md:h-8 w-auto shrink-0"
            draggable="false"
          />
        )}
        <span className="font-medium">{banner.text}</span>
        {banner.cta_label && banner.cta_url && (
          isExternal ? (
            <a
              href={banner.cta_url}
              target="_blank"
              rel="noreferrer"
              data-testid="banner-cta"
              className="underline underline-offset-4 font-semibold whitespace-nowrap"
            >
              {banner.cta_label} →
            </a>
          ) : (
            <Link
              to={banner.cta_url}
              data-testid="banner-cta"
              className="underline underline-offset-4 font-semibold whitespace-nowrap"
            >
              {banner.cta_label} →
            </Link>
          )
        )}
        <button
          aria-label="Dismiss"
          data-testid="banner-close"
          onClick={close}
          className="absolute right-4 opacity-70 hover:opacity-100"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
